import { atom } from 'recoil'

export const ModalMenuState = atom({
    key: 'modalMenuState',
    default: 0
})